export default __webpack_public_path__ + "static/header-ee85809c6505831272b26916459d28b8.jpg";